import { Injectable } from '@angular/core';
import { IdentityBrandingService } from './identityBranding.service';
import { WhiteLabelPropertyModel } from '../models/whitelabelpropertymodel';
import { SingleOrDefault } from '../_helpers/ArrayExtensionMethodHelper.functions';

declare function startConfetti(): void;
declare function stopConfetti(): void;

@Injectable({ providedIn: 'root' })
export class ConfettiService {

    /**
     * Whitelabel url to retrieve branding settings for:
     */
    currentDomain: string = "";

    /**
     * Default confetti is enabled:
     */
    confettiEnabled = true;

    constructor(private identityBrandingService: IdentityBrandingService) {
        this.grabBrandingSettings();
    }


    grabBrandingSettings() {
        this.currentDomain = window.location.host.toLowerCase();
        this.identityBrandingService.getWhitelabelProperties(this.currentDomain)
            .subscribe((data: WhiteLabelPropertyModel[]) => {
                var enabledconfettiProperty = SingleOrDefault(data, 'name', 'enabledconfetti');
                if (enabledconfettiProperty) {
                    this.confettiEnabled = enabledconfettiProperty.value != 'False' && enabledconfettiProperty.value != 'false'
                }
            });
    }

    /** 
     * Triggers a verify on showing Confetti, IF enabled for organisation (branding) displays confetti
     */
    triggerConfetti() {
        this.grabBrandingSettings();

        if (!this.confettiEnabled) {
            return;
        }
        startConfetti();
        setTimeout(() => {
            stopConfetti();
        }, 5000);
    }
}
